import { NOT_FOUND, Status } from "./typedefs/RequestStatus";
import { Site, Bible, Book, Chapter } from "./typedefs/BibleOffline";
import { BibleSiteStorable } from "./typedefs/BibleSiteStorage";

// Passthrough is a SiteStorable that does nothing.
// It fails to get any data so that other sources will be tried.
// It succeeds at saving data (without really doing so).
export const Passthrough: BibleSiteStorable = {
  getSite(
    fullSiteDomain: string
  ): Promise<{ site: Site | undefined; status: Status }> {
    return Promise.resolve({ site: undefined, status: NOT_FOUND });
  },
  getBible(
    bibleId: string
  ): Promise<{ bible: Bible | undefined; status: Status }> {
    return Promise.resolve({ bible: undefined, status: NOT_FOUND });
  },
  getBooks(
    bibleId: string
  ): Promise<{ books: Book[] | undefined; status: Status }> {
    return Promise.resolve({ books: undefined, status: NOT_FOUND });
  },
  getChapter(
    bibleId: string,
    chapterId: string
  ): Promise<{ chapter: Chapter | undefined; status: Status }> {
    return Promise.resolve({ chapter: undefined, status: NOT_FOUND });
  },
  setSite(site: Site): Promise<boolean> {
    return Promise.resolve(true);
  },
  setBible(bible: Bible): Promise<boolean> {
    return Promise.resolve(true);
  },
  setBooks(bibleId: string, books: Book[]): Promise<boolean> {
    return Promise.resolve(true);
  },
  setChapter(chapter: Chapter): Promise<boolean> {
    return Promise.resolve(true);
  },
  removeBible(bibleId: string): Promise<boolean> {
    return Promise.resolve(true);
  }
};
